module.exports = __webpack_public_path__ + "static/media/Group_icon.06663f01.svg";